/* Couples Set PDP — gallery (slides + video + lightbox), ring-sizer modal + dial, sticky ATC, ATC options gate */
(function () {
  function ready(fn){ document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  var RS_SIZES = [
    {us:'4',dia:14.9,circ:46.8,uk:'H½',eu:47},
    {us:'4.5',dia:15.3,circ:48.0,uk:'I½',eu:48},
    {us:'5',dia:15.7,circ:49.3,uk:'J½',eu:49},
    {us:'5.5',dia:16.1,circ:50.6,uk:'K½',eu:51},
    {us:'6',dia:16.5,circ:51.9,uk:'L½',eu:52},
    {us:'6.5',dia:16.9,circ:53.1,uk:'M½',eu:53},
    {us:'7',dia:17.3,circ:54.4,uk:'N½',eu:54},
    {us:'7.5',dia:17.7,circ:55.7,uk:'O½',eu:56},
    {us:'8',dia:18.1,circ:57.0,uk:'P½',eu:57},
    {us:'8.5',dia:18.5,circ:58.3,uk:'Q½',eu:58},
    {us:'9',dia:18.9,circ:59.5,uk:'R½',eu:60},
    {us:'9.5',dia:19.4,circ:60.8,uk:'S½',eu:61},
    {us:'10',dia:19.8,circ:62.1,uk:'T½',eu:62},
    {us:'10.5',dia:20.2,circ:63.4,uk:'U½',eu:63},
    {us:'11',dia:20.6,circ:64.6,uk:'V½',eu:65},
    {us:'11.5',dia:21.0,circ:65.9,uk:'W½',eu:66},
    {us:'12',dia:21.4,circ:67.2,uk:'Y',eu:67},
    {us:'12.5',dia:21.8,circ:68.5,uk:'Z',eu:69},
    {us:'13',dia:22.2,circ:69.7,uk:'Z+1',eu:70},
    {us:'13.5',dia:22.6,circ:71.0,uk:'Z+2',eu:71},
    {us:'14',dia:23.0,circ:72.3,uk:'Z+3',eu:72},
    {us:'14.5',dia:23.4,circ:73.6,uk:'Z+4',eu:74},
    {us:'15',dia:23.8,circ:74.8,uk:'Z+5',eu:75}
  ];

  ready(function () {
    /* title "Read more" — only shown when the 2-line clamp actually truncates the title */
    var title = document.getElementById('cspTitle');
    var titleMore = document.getElementById('cspTitleMore');
    if (title && titleMore) {
      var checkClamp = function () {
        if (title.classList.contains('expanded')) return;
        titleMore.hidden = (title.scrollHeight - title.clientHeight <= 1);
      };
      titleMore.addEventListener('click', function () {
        var expanded = title.classList.toggle('expanded');
        titleMore.textContent = expanded ? 'Read less' : 'Read more';
        titleMore.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
      checkClamp();
      window.addEventListener('resize', checkClamp);
      window.addEventListener('load', checkClamp);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(checkClamp);
    }

    /* gallery — thumbnails toggle slides; videos pause when their slide is hidden */
    var slides = document.querySelectorAll('.csp-slide');
    var thumbs = document.querySelectorAll('.csp-thumb');
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var centerThumb = function (t) {
      var tw = t && t.parentElement;
      if (!tw || tw.scrollWidth <= tw.clientWidth) return;
      var target = t.offsetLeft - (tw.clientWidth - t.offsetWidth) / 2;
      if (tw.scrollTo) { tw.scrollTo({ left: target, behavior: 'smooth' }); } else { tw.scrollLeft = target; }
    };
    /* Blue-frame fix, 2026-10-17: the video's own background is navy, and it showed whenever the slide opened before the
       poster or the first frame was ready. Paint the poster, and under it the gallery thumbnail the shopper already has, as
       the video's background, so the slide shows the picture at once. The thumbnail is already downloaded, so this costs
       nothing extra. It runs again when the slide opens, in case the thumbnail finished loading after the first call. */
    var coverVideo = function (vid) {
      var slide = vid.closest('.csp-slide');
      var th = slide && document.querySelector('.csp-thumb[data-idx="' + slide.getAttribute('data-idx') + '"] img');
      var urls = [vid.dataset.poster];
      if (th && th.complete && th.naturalWidth) urls.push(th.currentSrc || th.src);
      var bg = urls.filter(Boolean).map(function (u) { return 'url("' + u + '")'; }).join(', ');
      if (!bg || vid._feCover === bg) return;
      vid._feCover = bg;
      vid.style.backgroundImage = bg;
      vid.style.backgroundSize = 'contain';
      vid.style.backgroundPosition = 'center';
      vid.style.backgroundRepeat = 'no-repeat';
    };
    var armVideo = function (vid) {
      /* the gallery <video> is preload="none" and holds its poster in data-poster (PageSpeed decisions 3 and 15): poster and clip load only once its slide is opened */
      if (!vid.poster && vid.dataset.poster) vid.poster = vid.dataset.poster;
      coverVideo(vid);
    };
    var autoplaySlideVideo = function (vid) {
      armVideo(vid);
      /* video slide selected: start it muted (autoplay-safe); skipped for reduced motion */
      if (reduceMotion || !vid.paused) return;
      vid.muted = true;
      var p = vid.play(); if (p && p.catch) p.catch(function () {});
    };
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var idx = t.getAttribute('data-idx');
        thumbs.forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        slides.forEach(function (s) {
          var on = s.getAttribute('data-idx') === idx;
          s.classList.toggle('active', on);
          var vid = s.querySelector('video');
          if (!vid) return;
          if (on) { autoplaySlideVideo(vid); } else if (!vid.paused) { vid.pause(); }
        });
        centerThumb(t);
      });
    });
    var firstVid = document.querySelector('.csp-slide.active video');
    if (firstVid) autoplaySlideVideo(firstVid);
    /* Audit fix 2026-10-17 (Wade saw a blue frame on iPhone before the video), second pass the same day after he still saw
       it on iPhone and desktop: the first pass waited for the whole page to finish loading, and a shopper who opened the
       video sooner beat it. Each gallery video's poster is now fetched as soon as the main photo has loaded, so it never
       competes with that photo, and at once when the shopper first points at, touches or tabs into the gallery. The clip
       itself still loads only when its slide opens. Skipped when the visitor asks to save data; coverVideo() still
       covers that case with the thumbnail. */
    (function () {
      if (navigator.connection && navigator.connection.saveData) return;
      if (!document.querySelector('.csp-slide video')) return;
      var armed = false;
      var armAll = function () {
        if (armed) return;
        armed = true;
        Array.prototype.forEach.call(document.querySelectorAll('.csp-slide video'), function (v) { armVideo(v); });
      };
      var soon = function () { setTimeout(armAll, 50); };
      var gal = document.querySelector('.csp-gallery');
      if (gal) ['pointerover', 'pointerdown', 'touchstart', 'focusin'].forEach(function (n) { gal.addEventListener(n, armAll, { once: true, passive: true }); });
      var lead = document.querySelector('.csp-slide.active img');
      if (!lead || (lead.complete && lead.naturalWidth)) soon();
      else { lead.addEventListener('load', soon, { once: true }); lead.addEventListener('error', soon, { once: true }); }
      if (document.readyState === 'complete') soon(); else window.addEventListener('load', soon, { once: true });
    })();

    /* arrow / swipe navigation — steps by clicking the matching thumb (reuses the
       handler above, so videos pause correctly); keeps the active thumb in view
       when the mobile thumb row scrolls (horizontal only, never scrolls the page) */
    function cspStep(d) {
      var n = thumbs.length;
      if (n < 2) return;
      var cur = 0;
      thumbs.forEach(function (t, i) { if (t.classList.contains('active')) cur = i; });
      var t = thumbs[((cur + d) % n + n) % n];
      t.click();
      var tw = t.parentElement;
      if (tw && tw.scrollWidth > tw.clientWidth) {
        var target = t.offsetLeft - (tw.clientWidth - t.offsetWidth) / 2;
        if (tw.scrollTo) { tw.scrollTo({ left: target, behavior: 'smooth' }); } else { tw.scrollLeft = target; }
      }
    }
    var navPrev = document.querySelector('.csp-nav-prev');
    var navNext = document.querySelector('.csp-nav-next');
    if (navPrev) navPrev.addEventListener('click', function () { cspStep(-1); });
    if (navNext) navNext.addEventListener('click', function () { cspStep(1); });
    var galMain = document.querySelector('.csp-main');
    if (galMain && thumbs.length > 1) {
      /* swipe with direction lock: once a touch is moving mostly sideways the page stops scrolling
         vertically (touchmove is cancelled) and the active slide follows the finger; a mostly-vertical
         touch is handed to the browser untouched so the page still scrolls normally */
      var swX = 0, swY = 0, swOn = false, swLock = '', swSlide = null;
      galMain.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { swOn = false; return; }
        swOn = true; swLock = ''; swX = e.touches[0].clientX; swY = e.touches[0].clientY;
        swSlide = galMain.querySelector('.csp-slide.active');
        if (swSlide) swSlide.style.transition = 'none';
      }, { passive: true });
      galMain.addEventListener('touchmove', function (e) {
        if (!swOn) return;
        var dx = e.touches[0].clientX - swX, dy = e.touches[0].clientY - swY;
        if (!swLock) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          swLock = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        }
        if (swLock !== 'x') return;
        if (e.cancelable) e.preventDefault();
        if (swSlide) swSlide.style.transform = 'translateX(' + Math.max(-80, Math.min(80, dx * 0.35)) + 'px)';
      }, { passive: false });
      var swEnd = function (e) {
        if (!swOn) return;
        swOn = false;
        if (swSlide) { swSlide.style.transition = 'transform .18s ease'; swSlide.style.transform = ''; }
        var t = e.changedTouches && e.changedTouches[0];
        if (!t || swLock !== 'x') return;
        var dx = t.clientX - swX;
        if (Math.abs(dx) > 48) cspStep(dx < 0 ? 1 : -1);
      };
      galMain.addEventListener('touchend', swEnd, { passive: true });
      galMain.addEventListener('touchcancel', swEnd, { passive: true });
    }

    /* video slides — click anywhere on the video to play/pause; icon hides while playing */
    slides.forEach(function (sl) {
      var vid = sl.querySelector('video');
      var vbtn = sl.querySelector('.csp-video-btn');
      if (!vid || !vbtn) return;
      var sync = function () {
        var playing = !vid.paused && !vid.ended;
        sl.classList.toggle('playing', playing);
        vbtn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      };
      vbtn.addEventListener('click', function () {
        if (vid.paused || vid.ended) { armVideo(vid); vid.play().catch(function () {}); } else { vid.pause(); }
      });
      vid.addEventListener('play', sync);
      vid.addEventListener('pause', sync);
      vid.addEventListener('ended', sync);
      sync();
    });

    /* thumb strip: thumbs keep full size and scroll sideways; chevrons only when the strip overflows */
    var tWrap = document.querySelector('.csp-thumbs-wrap'), tStrip = document.querySelector('.csp-thumbs');
    if (tWrap && tStrip) {
      var syncTnav = function () {
        var over = tStrip.scrollWidth > tStrip.clientWidth + 1;
        tWrap.classList.toggle('has-overflow', over);
        tWrap.classList.toggle('at-start', tStrip.scrollLeft <= 1);
        tWrap.classList.toggle('at-end', tStrip.scrollLeft + tStrip.clientWidth >= tStrip.scrollWidth - 1);
      };
      tStrip.addEventListener('scroll', syncTnav, { passive: true });
      window.addEventListener('resize', syncTnav);
      window.addEventListener('load', syncTnav);
      syncTnav();
      var tPrev = tWrap.querySelector('.csp-tnav-prev'), tNext = tWrap.querySelector('.csp-tnav-next');
      var tScroll = function (d) { var by = Math.max(80, tStrip.clientWidth * 0.8) * d; if (tStrip.scrollBy) { tStrip.scrollBy({ left: by, behavior: reduceMotion ? 'auto' : 'smooth' }); } else { tStrip.scrollLeft += by; } };
      if (tPrev) tPrev.addEventListener('click', function () { tScroll(-1); });
      if (tNext) tNext.addEventListener('click', function () { tScroll(1); });
    }

    /* lightbox — click the active image slide to zoom (2048px source) */
    var lb = document.getElementById('cspLightbox');
    var lbImg = document.getElementById('cspLbImg');
    var mainWrap = document.querySelector('.csp-main');
    if (lb && lbImg && mainWrap) {
      mainWrap.addEventListener('click', function (e) {
        var img = e.target.closest ? e.target.closest('.csp-slide.active img[data-zoom]') : null;
        if (!img) return;
        lbImg.src = img.getAttribute('data-zoom');
        lbImg.alt = img.alt || '';
        lb.hidden = false;
        document.body.style.overflow = 'hidden';
      });
      var lbClose = function () { lb.hidden = true; lbImg.removeAttribute('src'); document.body.style.overflow = ''; };
      lb.addEventListener('click', lbClose);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) lbClose(); });
    }

    /* delivery estimate — merchant-declared rules (cutoff hour CT, min-max business
       days processing, min-max business days transit). Saturdays count as ship/delivery
       days when data-saturdays=1 (USPS Saturday pickup); Sundays always skipped;
       holidays are not. Dates recompute from the visitor's clock every minute. */
    var del = document.getElementById('cspDelivery');
    var engraveDays = 0; /* UX-01: engraving adds 3 business days of processing (same rule as mens-ring.js) */
    var updateDelivery = function () {};
    if (del) {
      updateDelivery = function () {
        var cutoff = +del.getAttribute('data-cutoff') || 8;
        var pmin = +del.getAttribute('data-processing-min') || 0;
        var pmax = Math.max(pmin, +del.getAttribute('data-processing') || 2);
        var tmin = +del.getAttribute('data-transit-min') || 3;
        var tmax = +del.getAttribute('data-transit-max') || 5;
        var sat = del.getAttribute('data-saturdays') === '1';
        var chi = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Chicago' }));
        var isBiz = function (d) { var w = d.getDay(); return w !== 0 && (sat || w !== 6); };
        var addBiz = function (d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (isBiz(x)) n--; } return x; };
        var beforeCutoff = isBiz(chi) && chi.getHours() < cutoff;
        var start = new Date(chi);
        if (!beforeCutoff) { do { start.setDate(start.getDate() + 1); } while (!isBiz(start)); }
        var arrMin = addBiz(addBiz(start, pmin + engraveDays), tmin);
        var arrMax = addBiz(addBiz(start, pmax + engraveDays), tmax);
        var fmt = function (d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); };
        var dates = document.getElementById('cspDeliveryDates');
        /* keep the whole range on one line — without this the break lands between month and
           day ("Sep" / "8"), splitting a date across two lines */
        if (dates && dates.style.whiteSpace !== 'nowrap') dates.style.whiteSpace = 'nowrap';
        if (dates) dates.textContent = fmt(arrMin) + ' – ' + fmt(arrMax);
      };
      updateDelivery();
      setInterval(updateDelivery, 60000);
    }

    /* Reassurance under the buy button. "Free engraving" is already promised twice directly
       above — the $30 badge and the Add Engraving control — so repeating it here is noise.
       TEXT ONLY: no colour or weight override. An earlier version made this green + bold to
       match .csp-sizenote-1, which was wrong — green already appears three times in this buy
       box, the checkmark device twice, and a saturated colour directly under the navy CTA
       competes with it. This line's job is to be found by someone looking for it, not to
       shout. The theme's own muted navy is correct; leave it alone. */
    var reassure = document.querySelector('.csp-reassure');
    if (reassure) reassure.textContent = 'Hassle-free returns';

    /* ATC options gate — the buy buttons render disabled and unlock only once the
       options app (VOPO/BCPO) has injected its properties fields into #csp-form.
       Prevents sizeless orders during the app's (sometimes very long) load window. */
    var gateBtns = document.querySelectorAll('[data-gate="options"]');
    var atcNote = document.getElementById('cspAtcNote');
    var cspForm = document.getElementById('csp-form');
    if (gateBtns.length && cspForm) {
      var hasOptions = function () {
        return !!cspForm.querySelector('select[name^="properties"], input[name^="properties"], textarea[name^="properties"]');
      };
      var unlock = function () {
        gateBtns.forEach(function (b) { b.disabled = false; });
        if (atcNote) atcNote.hidden = true;
        /* move the size-exchange note directly under the Her Ring Size dropdown
           (VOPO injects its fields at an unpredictable position in the form) */
        var note = document.getElementById('cspSizeNote');
        var her = cspForm.querySelector('select[name="properties[Her Ring Size]"]');
        if (note && her) {
          var wrap = her.closest('.selector-wrapper') || her.parentElement;
          if (wrap && wrap.parentElement) wrap.parentElement.insertBefore(note, wrap.nextSibling);
        }
        /* UX-04 (UX-laws audit 2026-09-08): the "Free engraving included / $30 value" badge and the
           app's "Add Engraving?" checkbox used to be two stacked blocks (45px + 80px) between the size
           selects and Add to Cart. Merge them: the badge becomes a <label> wrapping the checkbox, so the
           whole row is the tap target and the group costs one line. The input stays inside the app's
           .selector-wrapper, so the app's own change handling and syncEngrave() below keep working.
           Fallback (app rendered something other than a checkbox): the old position-only move. */
        var badge = document.querySelector('.csp-engrave');
        var engWrap = null;
        Array.prototype.slice.call(cspForm.querySelectorAll('.selector-wrapper')).forEach(function (g) {
          var t = g.querySelector('.bcpo-title');
          if (t && /add engraving/i.test(t.textContent || '')) engWrap = g;
        });
        if (badge && engWrap && engWrap.parentElement && !engWrap.classList.contains('csp-engrow')) {
          var engCb = engWrap.querySelector('input[type="checkbox"]');
          if (engCb) {
            var engRow = document.createElement('label');
            engRow.className = badge.className + ' csp-engrave--row';
            if (engCb.id) engRow.setAttribute('for', engCb.id);
            /* Wade 2026-09-10: one line on phones too. The words that do not fit at 360px ("included",
               "engraving") sit in .csp-engrave-more spans that the section CSS hides below 561px, so the
               phone row reads "Free engraving [$30 value] [ ] Add" and desktop keeps the full copy. */
            /* Each piece of copy is wrapped in ONE span: the row is display:flex, so a bare text node and
               a sibling span would become two flex items and the gap between them reads as a double space
               (and the leading space of " engraving" would be dropped). */
            engRow.innerHTML = badge.innerHTML.replace(/([^<>\s][^<>]*?)\s+included\b/, '<span class="csp-engrave-txt">$1<span class="csp-engrave-more"> included</span></span>');
            /* Wade 2026-09-19 (approved mock, option B): no icon, the checkbox leads the row, then "Free engraving" and the
               value pill; nothing on the right. The whole row is still the label, so it is all one tap target. */
            var engIcon = engRow.querySelector('svg'); if (engIcon) engIcon.parentNode.removeChild(engIcon);
            var engLbl = engRow.querySelector('.csp-engrave-txt'); if (engLbl) engLbl.textContent = 'Free engraving';
            engRow.insertBefore(engCb, engRow.firstChild);
            engWrap.classList.add('csp-engrow');
            engWrap.insertBefore(engRow, engWrap.firstChild);
            badge.parentNode.removeChild(badge);
          } else {
            engWrap.parentElement.insertBefore(badge, engWrap);
          }
        }
        /* Move "Find my ring size" below the size pair. Above the fields it answers a question
           the shopper has not been asked yet; below, it lands exactly where they stall.
           Inserted after the note above, so it ends up first: [sizes][link][note]. */
        var sizeLink = document.querySelector('.csp-sizelink');
        if (sizeLink && her) {
          var hw = her.closest('.selector-wrapper') || her.parentElement;
          if (hw && hw.parentElement) {
            hw.parentElement.insertBefore(sizeLink, hw.nextSibling);
            sizeLink.style.margin = '0 0 10px';
            var a = sizeLink.querySelector('a');
            if (a && !a.querySelector('svg')) {
              a.style.display = 'inline-flex';
              a.style.alignItems = 'center';
              a.style.gap = '6px';
              a.style.fontWeight = '500';
              /* a ruler: body plus graduated tick marks. The previous path drew a hexagon —
                 wrong icon entirely. */
              a.insertAdjacentHTML('afterbegin',
                '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
                'stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
                '<rect x="2" y="8" width="20" height="8" rx="1.5"/>' +
                '<path d="M6.5 8v3M10 8v4M13.5 8v3M17.5 8v4"/></svg>');
            }
          }
        }
        /* The strongest sizing reassurance this store has is that a sizer ships with the ring —
           it removes the hesitation without asking anyone to wait. Replaces the guess advice,
           which manufactured the exchanges the guarantee then paid for. */
        var n1 = document.querySelector('.csp-sizenote-1');
        var n2 = document.querySelector('.csp-sizenote-2');
        if (n1) n1.textContent = '✓ Ring sizer with every order';
        /* UX-36 (UX-laws audit 2026-09-08), Wade 2026-09-14 option A: the second line used to repeat
           "free size exchange", which the trust strip says again 200px lower. Remove it. */
        if (n2) n2.remove();
        /* Wade 2026-09-19: the sizer link and the sizer note share ONE line (link left, note right) */
        if (sizeLink && note && sizeLink.parentElement) { sizeLink.appendChild(note); sizeLink.classList.add('csp-sizerow'); }
      };
      /* UX-10 (UX-laws audit 2026-09-08), Wade 2026-09-10. Three things, all app-safe (the required fields
         and the app's option config are untouched):
         1. The line under the button swaps while engraving is on: "Hassle-free returns" becomes "Engraved
            items are final sale." (same spot the men's page uses), and the app's longer instruction line
            above the fields is hidden, so the disclosure is stated once and never next to a returns promise.
         2. The two app text fields are relabeled "His band" / "Her band" (Wade dropped the "Engrave both
            bands" heading). Visible label text only: the inputs' names (the line-item property keys on the
            order) are untouched.
         3. An empty size select or engraving box no longer gets the browser's tooltip ("Please select an
            item in the list." / "Please fill out this field."): the store's own red role="alert" line (same
            treatment as the men's size error, UX-32) is shown under the empty control and it is focused.
            Registered at DOCUMENT capture, like mens-ring.js's sizeGuard, so it runs before the app's
            handlers. Sizes are checked first, then engraving. */
      var engOn = false;
      var engFields = function () {
        /* matched on the input NAME (the order property key), which never changes; the visible title is relabeled below */
        return Array.prototype.slice.call(cspForm.querySelectorAll('.selector-wrapper')).filter(function (g) {
          /* 2026-10-03: any engraving text box ("His Ring Engraving (22 Characters Max)" today, "His Engraving" after the rename) */
          var ei = g.querySelector('input[type="text"], textarea');
          return !!ei && /engrav/i.test(ei.name || '');
        });
      };
      if (!document.getElementById('csp-ux10-css')) {
        var ux10Css = document.createElement('style');
        ux10Css.id = 'csp-ux10-css';
        ux10Css.textContent =
          '.csp-engrave-err[hidden],.csp-reassure[hidden]{display:none}' +
          '#csp-form .selector-wrapper.csp-instr-hide{display:none!important}' +
          '.csp-engrave-err{color:#BF1515;font-size:.875rem;line-height:1.3;font-weight:500;margin:-14px 0 14px;white-space:nowrap}' +
          '.csp-engrave-err.csp-size-err{margin:-16px 0 14px}' +
          '#csp-form input[aria-invalid="true"],#csp-form select[aria-invalid="true"]{border-color:#BF1515!important}';
        document.head.appendChild(ux10Css);
      }
      var engErr = document.createElement('div');
      engErr.className = 'csp-engrave-err';
      engErr.setAttribute('role', 'alert');
      engErr.hidden = true;
      var engraveUi = function (on) {
        engOn = !!on;
        /* Wade 2026-09-10 (second pass): the line under the button swaps instead of hiding. Off: "Hassle-free
           returns". On: "Engraved items are final sale." (the men's page says the same thing in the same spot).
           The app's own longer instruction line above the fields is hidden while this is in place, so the
           disclosure is stated once, in the slot the returns promise would otherwise occupy. */
        /* Wade 2026-09-19: no line at all while engraving is off ("Hassle-free returns" is already in the trust strip);
           it appears only as the final-sale disclosure while engraving is on */
        /* Wade 2026-09-23: the disclosure moved INTO the engraving box, under the two boxes (the options snippet renders
           the products' instructions line with the approved wording and the section CSS makes it the box's last row).
           Nothing is shown under the button any more, on or off, and the instructions wrapper is no longer hidden. */
        if (reassure) { reassure.textContent = 'Hassle-free returns'; reassure.hidden = true; }
        var fields = engFields();
        fields.forEach(function (g) {
          var t = g.querySelector('.bcpo-title');
          if (!t || g.getAttribute('data-csp-relabeled')) return;
          /* 2026-10-03: both names are accepted - "His Ring Engraving (22 Characters Max)" and the new "His Engraving".
             The limit comes from the box's own maxlength when the name no longer carries it. */
          var m = /^\s*(His|Her)\s+(?:Ring\s+)?Engraving\s*(?:\((\d+)\s*Characters?\s*Max\))?\s*:?\s*$/i.exec(t.textContent || '');
          if (!m) return;
          /* 2026-10-07 colour cards: the HIS / HER chip (CSS ::before on the box) names the ring, so the title is just "engraving" */
          t.textContent = 'engraving';
          /* Wade 2026-09-19: the limit is written IN the box */
          var engInp = g.querySelector('input[type="text"], textarea');
          var engMax = m[2] || (engInp && engInp.maxLength > 0 ? String(engInp.maxLength) : '');
          if (engInp && engMax) engInp.setAttribute('placeholder', engMax + ' characters max');
          /* Wade 2026-09-19: one band is enough, so a data-level "required" on these boxes is lifted; the guard below enforces at least one */
          var rq = g.querySelector('input[required], textarea[required]'); if (rq) rq.removeAttribute('required');
          g.setAttribute('data-csp-relabeled', '1');
        });
        if (!engOn && !engErr.hidden) clearEngErr();
      };
      var clearEngErr = function () {
        engErr.hidden = true;
        Array.prototype.slice.call(cspForm.querySelectorAll('[aria-invalid="true"]')).forEach(function (i) { i.removeAttribute('aria-invalid'); });
      };
      /* Wade 2026-09-10 (third pass): the size selects get the same treatment as the engraving boxes, so
         the browser's "Please select an item in the list." tooltip is gone too. One shared guard: sizes
         first, then engraving. Copy is kept short enough to stay on one line at 360px. */
      var sizeErr = document.createElement('div');
      sizeErr.className = 'csp-engrave-err csp-size-err';
      sizeErr.setAttribute('role', 'alert');
      sizeErr.hidden = true;
      var sizeSels = function () {
        return Array.prototype.slice.call(cspForm.querySelectorAll('select[name="properties[His Ring Size]"], select[name="properties[Her Ring Size]"]'));
      };
      var emptySizes = function () { return sizeSels().filter(function (s) { return !s.value; }); };
      var clearSizeErr = function () {
        sizeErr.hidden = true;
        sizeSels().forEach(function (s) { s.removeAttribute('aria-invalid'); });
      };
      var emptyEngInputs = function () {
        if (!engOn) return [];
        return engFields().map(function (g) { return g.querySelector('input[type="text"], textarea'); })
          .filter(function (i) { return i && !(i.value || '').trim(); });
      };
      var flag = function (el, errEl, text) {
        var wrap = el.closest('.selector-wrapper') || el.parentElement;
        wrap.insertAdjacentElement('afterend', errEl);
        errEl.textContent = text;
        errEl.hidden = false;
        el.setAttribute('aria-invalid', 'true');
        if (el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { el.focus(); }, 350);
      };
      var atcGuard = function (e) {
        var onAtc = e.type === 'click' && e.target && e.target.closest && e.target.closest('[data-gate="options"]');
        var onForm = e.type === 'submit' && e.target === cspForm;
        if (!onAtc && !onForm) return;
        var sizes = emptySizes();
        if (sizes.length) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var whose = /her ring/i.test(sizes[0].name || '') ? 'her' : 'his';
          flag(sizes[0], sizeErr, sizes.length > 1 ? 'Choose both ring sizes to continue.' : 'Choose ' + whose + ' ring size to continue.');
          return;
        }
        clearSizeErr();
        var empties = emptyEngInputs();
        /* Wade 2026-09-19: with engraving on, at least ONE band must carry text (it used to demand both) */
        var engBoxes = engOn ? engFields().length : 0;
        if (!empties.length || empties.length < engBoxes) { clearEngErr(); return; }
        e.preventDefault();
        e.stopImmediatePropagation();
        var band = /\[her /i.test(empties[0].name || '') ? 'her' : 'his';
        flag(empties[0], engErr, empties.length > 1 ? 'Add engraving for at least one band.' : 'Add ' + band + " band's engraving.");
      };
      document.addEventListener('click', atcGuard, true);
      document.addEventListener('submit', atcGuard, true);
      /* Size swap check (Wade 2026-10-08). Study of 5,912 couples orders (couples-size-swaps-2026-10-07): the His and
         Her sizes are put in the wrong boxes on about 2 of 100 orders, almost always by the buyer; the staff "Confirm
         Sizes" emails that used to catch most of them were stopped 2026-10-07. When both sizes are chosen and HIS is
         smaller than HER (any gap; 1 in 4 such orders is a swap, 3 in 4 are couples where her finger is bigger), a
         one-line question appears under the size cards: "Just checking: his size 7 is smaller than hers, 10. Is that
         right?" with "Yes, that's right" (hides it for that pair of sizes) and "Swap them" (exchanges the two
         selections; only offered when each size exists in the other ring's ladder). It asks, it does not warn: the
         strip is paper-tinted, not red. Never shown for equal sizes or His larger. Styled by the section CSS
         (.csp-swapcheck); sits at grid order 2, right under the cards. The element is created on first use, so the
         first paint (fe-pdp-early-layout) is unchanged. Selecting a size dispatches no synthetic events except on
         "Swap them", which fires 'change' on both selects so the chosen-value labels and the size guard update. */
      var swapBox = null, swapOkKey = '';
      var sizeNum = function (v) {
        var m = /^\s*(\d+)(?:\s*(?:\.5|1\/2|½))?\s*(?:US)?\s*$/i.exec(v || '');
        if (!m) return NaN;
        return parseInt(m[1], 10) + (/(\.5|1\/2|½)/.test(v) ? 0.5 : 0);
      };
      var sizeText = function (sel) { var o = sel.options[sel.selectedIndex]; return (o ? o.textContent : sel.value).trim(); };
      var hasOpt = function (sel, v) { return Array.prototype.some.call(sel.options, function (o) { return o.value === v; }); };
      var swapSels = function () {
        var his = cspForm.querySelector('select[name="properties[His Ring Size]"]');
        var her = cspForm.querySelector('select[name="properties[Her Ring Size]"]');
        return his && her ? { his: his, her: her } : null;
      };
      var swapHide = function () { if (swapBox) swapBox.hidden = true; };
      var swapCheck = function () {
        var p = swapSels(); if (!p) return;
        var h = sizeNum(p.his.value), w = sizeNum(p.her.value);
        var key = p.his.value + '|' + p.her.value;
        if (!p.his.value || !p.her.value || isNaN(h) || isNaN(w) || h >= w || key === swapOkKey) { swapHide(); return; }
        if (!swapBox) {
          swapBox = document.createElement('div');
          swapBox.className = 'csp-swapcheck';
          swapBox.setAttribute('role', 'status');
          swapBox.innerHTML = '<p class="csp-swapcheck-txt"></p><div class="csp-swapcheck-btns">' +
            '<button type="button" class="csp-swapcheck-ok">Yes, that’s right</button>' +
            '<button type="button" class="csp-swapcheck-swap">Swap them</button></div>';
          swapBox.querySelector('.csp-swapcheck-ok').addEventListener('click', function () {
            var q = swapSels(); if (q) swapOkKey = q.his.value + '|' + q.her.value;
            swapHide();
          });
          swapBox.querySelector('.csp-swapcheck-swap').addEventListener('click', function () {
            var q = swapSels(); if (!q) return;
            var a = q.his.value, b = q.her.value;
            if (!hasOpt(q.his, b) || !hasOpt(q.her, a)) return;
            q.his.value = b; q.her.value = a;
            q.his.dispatchEvent(new Event('change', { bubbles: true }));
            q.her.dispatchEvent(new Event('change', { bubbles: true }));
            swapHide();
          });
        }
        var txt = swapBox.querySelector('.csp-swapcheck-txt');
        txt.innerHTML = 'Just checking: <b>his</b> size ' + sizeText(p.his) + ' is smaller than <b>hers</b>, ' + sizeText(p.her) + '. Is that right?';
        swapBox.querySelector('.csp-swapcheck-swap').hidden = !(hasOpt(p.his, p.her.value) && hasOpt(p.her, p.his.value));
        var wrap = p.her.closest('.selector-wrapper') || p.her.parentElement;
        if (swapBox.parentElement !== wrap.parentElement) wrap.insertAdjacentElement('afterend', swapBox);
        swapBox.hidden = false;
      };
      cspForm.addEventListener('change', function (e) {
        if (e.target && e.target.tagName === 'SELECT' && /Ring Size\]$/.test(e.target.name || '')) swapCheck();
      });
      cspForm.addEventListener('input', function (e) {
        if (engErr.hidden || !e.target) return;
        if ((e.target.value || '').trim()) {
          e.target.removeAttribute('aria-invalid');
          engErr.hidden = true;
          Array.prototype.slice.call(cspForm.querySelectorAll('[aria-invalid="true"]')).forEach(function (i) { if (i.tagName !== 'SELECT') i.removeAttribute('aria-invalid'); });
        }
      });
      cspForm.addEventListener('change', function (e) {
        if (sizeErr.hidden || !e.target || e.target.tagName !== 'SELECT') return;
        if (e.target.value) e.target.removeAttribute('aria-invalid');
        var left = emptySizes();
        if (!left.length) { sizeErr.hidden = true; return; }
        /* one size picked, the other still empty: move the line under the remaining select and reword it (no refocus) */
        var w2 = left[0].closest('.selector-wrapper') || left[0].parentElement;
        w2.insertAdjacentElement('afterend', sizeErr);
        sizeErr.textContent = 'Choose ' + (/her ring/i.test(left[0].name || '') ? 'her' : 'his') + ' ring size to continue.';
        left[0].setAttribute('aria-invalid', 'true');
      });
      /* UX-01 (UX-laws audit 2026-09-08): engraving moves the delivery band, exactly as mens-ring.js
         does (engravingGuard -> engraveDays = 3 -> re-render). Engraving is "on" when the BCPO
         "Add Engraving?" control is set to yes OR either engraving text field has content. BCPO
         injects and re-injects async, so a persistent, coalesced observer re-checks after every
         mutation instead of relying on the one-shot unlock observer below. */
      var syncEngrave = function () {
        var on = false;
        var ctlSeen = false;
        Array.prototype.slice.call(cspForm.querySelectorAll('.selector-wrapper')).forEach(function (g) {
          var t = g.querySelector('.bcpo-title');
          if (!t || !/add engraving/i.test(t.textContent || '')) return;
          Array.prototype.slice.call(g.querySelectorAll('input[type="checkbox"], input[type="radio"], select')).forEach(function (c) {
            ctlSeen = true;
            if (c.tagName === 'SELECT') { if (/yes/i.test(c.value || '')) on = true; }
            else if (c.checked && !/^(no|none|0|false)$/i.test((c.value || '').trim())) on = true;
          });
        });
        /* UX-10: when the app renders an on/off control, that control is the truth. Text left behind in a
           field the app has hidden (untick after typing) must not keep the +3 days and the returns line
           hidden. The text fallback is only for a layout with no such control. */
        if (!on && !ctlSeen) {
          on = Array.prototype.slice.call(cspForm.querySelectorAll('input[type="text"], textarea')).some(function (f) {
            return f.name !== 'id' && f.value && f.value.trim().length > 0;
          });
        }
        var extra = on ? 3 : 0;
        if (extra !== engraveDays) { engraveDays = extra; updateDelivery(); }
        engraveUi(on);
      };
      cspForm.addEventListener('input', syncEngrave);
      cspForm.addEventListener('change', syncEngrave);
      var engScheduled = false;
      new MutationObserver(function () {
        if (engScheduled) return;
        engScheduled = true;
        setTimeout(function () { engScheduled = false; syncEngrave(); }, 60);
      }).observe(cspForm, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked', 'value', 'class', 'style'] });
      syncEngrave();
      if (hasOptions()) {
        unlock();
      } else {
        var mo = new MutationObserver(function () {
          if (hasOptions()) { unlock(); mo.disconnect(); }
        });
        mo.observe(cspForm, { childList: true, subtree: true });
      }
    }

    /* ring sizer modal */
    var modal = document.getElementById('rsModal');
    if (modal) {
      var openBtn = document.getElementById('cspSizeOpen');
      var cal = document.getElementById('rsCal');
      var card = document.getElementById('rsCard');
      var size = document.getElementById('rsSize');
      var ring = document.getElementById('rsRing');
      var read = document.getElementById('rsReadout');

      function update() {
        if (!cal || !size) return;
        var cardPx = +cal.value;
        if (card) {
          /* ISO ID-1 card = 85.6mm tall x 53.98mm wide (held upright). Set both
             dimensions explicitly so the short side stays accurate regardless of
             any theme .rs-card overrides. */
          card.style.setProperty('height', cardPx + 'px', 'important');
          card.style.setProperty('width', (Math.round(cardPx * 53.98 / 85.6 * 10) / 10) + 'px', 'important');
          card.style.setProperty('max-width', 'none', 'important');
        }
        var pxPerMm = cardPx / 85.6;
        var s = RS_SIZES[+size.value];
        var d = Math.round(s.dia * pxPerMm);
        if (ring) {
          /* the ring's inside diameter should equal the INNER edge of the stroke,
             so grow the (border-box) circle by the stroke width on each side */
          var bw = parseFloat(getComputedStyle(ring).borderTopWidth) || 1;
          var outer = d + 2 * bw;
          ring.style.width = outer + 'px';
          ring.style.height = outer + 'px';
        }
        if (read) read.textContent = 'US ' + s.us + '  ·  ' + s.dia + ' mm  ·  UK ' + s.uk + '  ·  EU ' + s.eu;
      }
      function show(e) {
        if (e && e.preventDefault) e.preventDefault(); /* #cspSizeOpen carries a real href (/pages/ring-sizer, PageSpeed decision 75); the click stays here and opens the modal */
        modal.hidden = false; document.body.style.overflow = 'hidden';
        var hasCal = calApply(); update(); applyRefresh();
        dialMoved = false;
        rsTrack('ring_sizer_open', { calibration: hasCal ? 'saved' : 'none' });
      }
      function hide() { modal.hidden = true; document.body.style.overflow = ''; calRedo = false; applyRefresh(); }

      var RS_PAGE = 'couples', MODAL = modal, CAL = cal, CARD = card, DIAL = size, RING = ring, READ = read;
      /* ---------- UX-09 (UX-laws audit 2026-09-08; built at Wade's request 2026-09-11) ----------
         1. The dial's answer goes straight into the size dropdown(s) - see the apply block below.
            Nothing is ever preselected: only a tap fills a size (made to order; engraved rings are final sale).
            A reading the ring is not made in disables the button and names the range instead of rounding to a
            neighbor. All button copy measured to fit one line at 360px.
         2. Step 2 is gated behind an explicit "This matches my card" tap (Wade 2026-09-11; the standalone Ring Sizer page
            uses the same words): until then the circle, dial, answer and apply buttons stay hidden, because a ring matched
            on an uncalibrated screen gives a wrong size. The confirmed calibration is remembered on this device
            (localStorage "fe-rs-card", shared by every ring page; saved only on that tap, never while dragging), so a
            return visit starts with step 1 folded to "1. Screen calibrated ✓ Redo" and step 2 open. Redo reopens step 1
            and gates step 2 again. Keyed on devicePixelRatio: a browser zoom change alters CSS px per mm, so a value saved
            at another zoom level is ignored. Storage can throw (private mode, blocked storage); every access is guarded,
            and the gate still works for the visit - it just is not remembered.
         3. Sizer use is counted in GA4. The Google & YouTube app already runs gtag on the page with the store's GA4 stream
            configured; send_to keeps these events out of the Google Ads tag. Events: ring_sizer_open (calibration
            saved|none), ring_sizer_tab (sizer_tab), ring_sizer_calibrate (card confirmed), ring_sizer_dial (first move of
            the dial per open), ring_sizer_use_size (ring his|her|single, ring_size). Every event carries sizer_page. */
      if (!document.getElementById('rs-ux09-css')) {
        /* .rs-apply max-width 440px: the standalone Ring Sizer page's stylesheet is compiled site-wide and caps
           .rs-readout at 440px from 920px up, so on desktop the buttons match the answer box above them. */
        var ux09Css = document.createElement('style');
        ux09Css.id = 'rs-ux09-css';
        ux09Css.textContent =
          '#rsModal .rs-apply{display:flex;gap:8px;margin:12px 0 0;max-width:440px}' +
          '#rsModal .rs-apply-btn{flex:1 1 0;min-width:0;min-height:44px;border:1.5px solid #4C3799;background:#fff;color:#4C3799;border-radius:12px;font:inherit;font-size:14px;font-weight:600;line-height:1.2;padding:0 8px;white-space:nowrap;cursor:pointer}' +
          '#rsModal .rs-apply-btn.is-set{background:#4C3799;color:#fff}' +
          '#rsModal .rs-apply-btn:disabled{border-color:#DCD9E8;background:#fff;color:#6E6A85;cursor:default}' +
          '#rsModal .rs-apply-btn:focus-visible,#rsModal .rs-redo:focus-visible,#rsModal .rs-calconfirm:focus-visible{outline:2px solid #4C3799;outline-offset:2px}' +
          '#rsModal .rs-calconfirm{display:block;width:100%;min-height:44px;margin:0 0 16px;padding:0 12px;background:#4C3799;color:#fff;border:0;border-radius:12px;font:inherit;font-size:14px;font-weight:600;line-height:1.2;cursor:pointer}' +
          '#rsModal .rs-redo{display:inline-flex;align-items:center;min-height:44px;margin:-12px 0;padding:0 8px;background:none;border:0;font:inherit;font-size:14px;color:#4C3799;text-decoration:underline;text-underline-offset:3px;cursor:pointer}';
        document.head.appendChild(ux09Css);
      }
      var rsTrack = function (name, params) {
        try {
          if (typeof window.gtag !== 'function') return;
          var id = 'G-CNG4X1659M', dl = window.dataLayer || [];
          for (var i = 0; i < dl.length; i++) { if (dl[i] && dl[i][0] === 'config' && /^G-/.test(dl[i][1] || '')) { id = dl[i][1]; break; } }
          var p = { send_to: id, sizer_page: RS_PAGE };
          if (params) for (var k in params) if (Object.prototype.hasOwnProperty.call(params, k)) p[k] = params[k];
          window.gtag('event', name, p);
        } catch (e) { }
      };
      var rsNorm = function (t) { var m = /^\s*(\d+)(?:\s+1\/2|\.5)\s*$/.exec(String(t)); return m ? +m[1] + 0.5 : parseFloat(t); };
      var rsFmt = function (v) { return String(v).replace(/\s+1\/2\s*$/, '.5'); };
      var RS_CAL_KEY = 'fe-rs-card';
      var calSaved = function () {
        if (!CAL) return null;
        try {
          var o = JSON.parse(window.localStorage.getItem(RS_CAL_KEY) || 'null');
          if (o && o.dpr === (window.devicePixelRatio || 1) && +o.px >= +CAL.min && +o.px <= +CAL.max) return +o.px;
        } catch (e) { }
        return null;
      };
      var calStore = function () {
        try { window.localStorage.setItem(RS_CAL_KEY, JSON.stringify({ px: +CAL.value, dpr: window.devicePixelRatio || 1, t: Date.now() })); } catch (e) { }
      };
      var dialPanel = MODAL.querySelector('.rs-panel[data-panel="dial"]');
      var rsSteps = dialPanel ? dialPanel.querySelectorAll('.rs-step') : [];
      var calStep = rsSteps[0] || null, step2Head = rsSteps[1] || null;   // "1. Calibrate your screen" / "2. Match a ring you own"
      var calOk = null, calConfirm = null, calRedo = false, dialMoved = false;
      var rsShowEl = function (el, on) { if (!el) return; if (on) el.style.removeProperty('display'); else el.style.setProperty('display', 'none', 'important'); };
      var calApply = function () {
        var px = calSaved();
        if (!calConfirm) return px !== null;   // markup not as expected: leave the sizer exactly as the theme renders it
        var done = px !== null && !calRedo;
        if (done && +CAL.value !== px) CAL.value = px;
        [calStep, CARD, CAL, calConfirm].forEach(function (el) { rsShowEl(el, !done); });
        rsShowEl(calOk, done);
        [step2Head, RING, DIAL, READ, MODAL.querySelector('.rs-apply')].forEach(function (el) { rsShowEl(el, done); });
        return px !== null;
      };
      if (calStep && step2Head && CAL && DIAL) {
        calConfirm = document.createElement('button');
        calConfirm.type = 'button';
        calConfirm.className = 'rs-calconfirm';
        calConfirm.textContent = 'This matches my card';
        CAL.insertAdjacentElement('afterend', calConfirm);
        calConfirm.addEventListener('click', function (e) {
          calStore();
          calRedo = false;
          calApply(); applyRefresh();
          if (e.isTrusted) rsTrack('ring_sizer_calibrate');
          try { DIAL.focus({ preventScroll: true }); } catch (x) { DIAL.focus(); }
        });
        /* A phone-size card box (~480-520px tall once matched) pushes the slider and this button below the sizer's
           visible area. When the shopper lets go of the slider ("change" fires on release), scroll just enough to bring
           the button into view - the gate must never sit offscreen. Not on "input": moving the box mid-drag would
           shift it under the card being held against the screen. */
        CAL.addEventListener('change', function () {
          var d = MODAL.querySelector('.rs-dialog');
          if (!d || calConfirm.style.getPropertyValue('display') === 'none') return;
          var over = calConfirm.getBoundingClientRect().bottom + 12 - Math.min(d.getBoundingClientRect().bottom, window.innerHeight);
          if (over <= 0) return;
          var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (d.scrollBy && !calm) d.scrollBy({ top: over, behavior: 'smooth' }); else d.scrollTop += over;
        });
        calOk = document.createElement('div');
        calOk.className = 'rs-step rs-calok';
        rsShowEl(calOk, false);
        calOk.innerHTML = '<b>1. Screen calibrated ✓</b> <button type="button" class="rs-redo">Redo</button>';
        calConfirm.insertAdjacentElement('afterend', calOk);
        calOk.querySelector('.rs-redo').addEventListener('click', function () { calRedo = true; calApply(); CAL.focus(); });
      }
      if (DIAL) DIAL.addEventListener('input', function (e) {
        applyRefresh();
        if (e.isTrusted && !dialMoved) { dialMoved = true; rsTrack('ring_sizer_dial'); }
      });
      var rsReading = function () { return DIAL ? RS_SIZES[+DIAL.value].us : null; };

      /* apply (couples): one button per ring under the readout. A tapped button turns into "✓ Her ring: 6" and the sizer
         stays open so the second ring can be matched; the label always reports what that dropdown holds, and tapping it
         again puts the current reading in its place. The half-width buttons hold 114px of text at 360px; the longest
         label, "✓ Her ring: 10.5", is 98px. The app renders the dropdowns late, so a sizer opened first polls for them. */
      var applyWrap = null, applyPoll = null;
      var ringSel = function (ring) { return document.querySelector('#csp-form select[name="properties[' + (ring === 'his' ? 'His' : 'Her') + ' Ring Size]"]'); };
      var ringOpts = function (sel) { return Array.prototype.slice.call(sel.options).filter(function (o) { return o.value && !o.disabled; }); };
      var applyRefresh = function () {
        if (!applyWrap) return;
        var us = rsReading(), missing = false;
        Array.prototype.forEach.call(applyWrap.children, function (b) {
          var ring = b.getAttribute('data-ring'), who = ring === 'his' ? 'His' : 'Her', sel = ringSel(ring);
          var label, aria, set = false, off = false;
          if (!sel) { missing = true; off = true; label = 'Use for ' + ring + ' ring'; aria = label; }
          else {
            var opts = ringOpts(sel);
            var fits = opts.some(function (o) { return rsNorm(o.value) === rsNorm(us); });
            if (!fits && opts.length) {
              off = true;
              label = who + ' sizes ' + rsFmt(opts[0].value) + '–' + rsFmt(opts[opts.length - 1].value);
              aria = who + ' ring comes in sizes ' + rsFmt(opts[0].value) + ' to ' + rsFmt(opts[opts.length - 1].value) + '; US ' + us + ' is not available';
            } else if (sel.value) {
              set = true;
              label = '✓ ' + who + ' ring: ' + rsFmt(sel.value);
              aria = who + ' ring is size ' + rsFmt(sel.value) + (rsNorm(sel.value) === rsNorm(us) ? '' : '. Tap to use US ' + us + ' instead');
            } else { label = 'Use for ' + ring + ' ring'; aria = 'Use US ' + us + ' for ' + ring + ' ring'; }
          }
          if (b.textContent !== label) b.textContent = label;
          b.disabled = off;
          b.classList.toggle('is-set', set);
          b.setAttribute('aria-label', aria);
        });
        if (missing && !modal.hidden && !applyPoll) applyPoll = setInterval(applyRefresh, 600);
        if ((!missing || modal.hidden) && applyPoll) { clearInterval(applyPoll); applyPoll = null; }
      };
      if (read) {
        applyWrap = document.createElement('div');
        applyWrap.className = 'rs-apply';
        applyWrap.setAttribute('aria-live', 'polite');
        ['his', 'her'].forEach(function (ring) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'rs-apply-btn';
          b.setAttribute('data-ring', ring);
          b.addEventListener('click', function () {
            var sel = ringSel(ring), us = rsReading();
            if (!sel || us === null) return;
            var o = ringOpts(sel).filter(function (x) { return rsNorm(x.value) === rsNorm(us); })[0];
            if (!o) return;
            if (sel.value !== o.value) {
              sel.value = o.value;
              sel.dispatchEvent(new Event('change', { bubbles: true }));
              rsTrack('ring_sizer_use_size', { ring: ring, ring_size: us });
            }
            applyRefresh();
          });
          applyWrap.appendChild(b);
        });
        read.insertAdjacentElement('afterend', applyWrap);
      }

      if (openBtn) openBtn.addEventListener('click', show);
      modal.querySelectorAll('[data-rs-close]').forEach(function (el) { el.addEventListener('click', hide); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) hide(); });

      /* ---------- sizing methods: order fastest-first, then offer the mailed sizer ----------
         Theme ships tabs as print / dial / chart with print landing. Printable is the only
         method needing a printer, so it should not be the default; the dial works with any
         screen and a bank card. Runs BEFORE the tab click handlers below so the new tab is
         wired by the same code as the originals. Styles are inline on purpose — the .rs-btn
         classes are defined for the standalone sizer page, not verified inside this modal. */
      var rsTabs = modal.querySelector('.rs-tabs');
      if (rsTabs) {
        /* Wade 2026-09-11: all four methods must be visible at once. The earlier swipeable row put "Free sizer by mail"
           entirely offscreen (its label started ~100px past the edge at 390px), so customers never knew it existed, and
           because overflow-x:auto also makes the row a vertical scroller it could be dragged up and down by a pixel.
           Now the row is not a scroller at all: short labels (set below: Dial | Size chart | Print | Free ring sizer,
           208px of text) fit one row in the 268px the dialog gives it at 360px. flex-wrap only matters if a shopper's
           enlarged text no longer fits - a tab then drops to a second row instead of hiding offscreen. */
        if (!document.getElementById('rs-tabstrip-css')) {
          var tabCss = document.createElement('style');
          tabCss.id = 'rs-tabstrip-css';
          tabCss.textContent =
            '#rsModal .rs-tabs{display:flex;flex-wrap:wrap;justify-content:space-between;gap:0;overflow:visible}' +
            '#rsModal .rs-tab{white-space:nowrap;flex:0 0 auto;padding-left:6px;padding-right:6px}' +
            '@media (min-width:600px){#rsModal .rs-tabs{justify-content:flex-start;gap:20px}#rsModal .rs-tab{padding-left:12px;padding-right:12px}}';
          document.head.appendChild(tabCss);
        }
        var rsTab = function (k) { return modal.querySelector('.rs-tab[data-tab="' + k + '"]'); };
        var rsPanel = function (k) { return modal.querySelector('.rs-panel[data-panel="' + k + '"]'); };
        ['dial', 'chart', 'print'].forEach(function (k) {
          var t = rsTab(k); if (t) rsTabs.appendChild(t);
          var p = rsPanel(k); if (p) p.classList.remove('active');
          if (t) t.classList.remove('active');
        });
        var dTab = rsTab('dial'), dPanel = rsPanel('dial');
        if (dTab) dTab.classList.add('active');
        if (dPanel) dPanel.classList.add('active');
        /* Wade 2026-09-11: short labels so all four fit one row at 360px (see the stylesheet above) */
        var tabLabels = { dial: 'Dial', chart: 'Size chart', print: 'Print' };
        Object.keys(tabLabels).forEach(function (k) { var t = rsTab(k); if (t) t.textContent = tabLabels[k]; });

        if (!rsTab('mail')) {
          var mTab = document.createElement('button');
          mTab.type = 'button';
          mTab.className = 'rs-tab';
          mTab.setAttribute('data-tab', 'mail');
          mTab.textContent = 'Free ring sizer';
          rsTabs.appendChild(mTab);

          var mPanel = document.createElement('div');
          mPanel.className = 'rs-panel';
          mPanel.setAttribute('data-panel', 'mail');
          mPanel.innerHTML =
            '<div style="background:#F7F4FC;border-radius:10px;padding:14px;">' +
              '<p style="margin:0 0 6px;font-size:14px;font-weight:500;color:#3C3489;">Rather size before you order?</p>' +
              '<p style="margin:0 0 12px;font-size:13px;line-height:1.5;color:#534AB7;">We\'ll mail you a free plastic sizer with $5 credit toward your ring. US only. A sizer also ships with every ring order.</p>' +
              '<button type="button" data-rs-mail-add="45538170404995" style="width:100%;background:#4C3799;color:#fff;border:0;border-radius:12px;padding:12px;font:inherit;font-size:14px;font-weight:500;cursor:pointer;">Get a free ring sizer</button>' +
            '</div>';
          var allPanels = modal.querySelectorAll('.rs-panel');
          var lastPanel = allPanels[allPanels.length - 1];
          if (lastPanel && lastPanel.parentElement) lastPanel.parentElement.appendChild(mPanel);

          /* Not a <form action="/cart/add"> on purpose. The Best Custom Product Options app
             hooks every add-to-cart form on the page and runs the RING's required option
             validation against it, so the sizer's native POST never fired: the click only
             produced a "Please select an item in the list" bubble on the size dropdowns
             behind the modal. Add the sizer through cart/add.js instead and hand the
             result to the theme the same way its own product-form does (bundled drawer
             section + cart:change), so the cart drawer refreshes and opens. Falls back to
             the GET permalink (full page to /cart) if anything in that path fails. */
          var mailAdd = mPanel.querySelector('[data-rs-mail-add]');
          if (mailAdd) mailAdd.addEventListener('click', function () {
            if (mailAdd.getAttribute('aria-busy') === 'true') return;
            var vid = mailAdd.getAttribute('data-rs-mail-add');
            var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
            var fallback = function () { window.location.href = root + 'cart/add?id=' + vid + '&quantity=1'; };
            if (!window.fetch || !window.FormData) { fallback(); return; }
            mailAdd.setAttribute('aria-busy', 'true');
            var sections = [];
            document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
            var fd = new FormData();
            fd.set('id', vid);
            fd.set('quantity', '1');
            fd.set('sections', sections.join(','));
            fd.set('sections_url', root + 'variants/' + vid);
            fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
              .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'add failed'); return j; }); })
              .then(function (added) {
                var st = (window.themeVariables && window.themeVariables.settings) || {};
                if (st.cartType === 'page' || st.pageType === 'cart') { window.location.href = root + 'cart'; return; }
                return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
                  cart.sections = added.sections || {};
                  hide();
                  document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
                });
              })
              .catch(fallback)
              .then(function () { mailAdd.removeAttribute('aria-busy'); });
          });
        }
      }

      modal.querySelectorAll('.rs-tab').forEach(function (tab) {
        tab.addEventListener('click', function (e) {
          modal.querySelectorAll('.rs-tab').forEach(function (x) { x.classList.remove('active'); });
          modal.querySelectorAll('.rs-panel').forEach(function (x) { x.classList.remove('active'); });
          tab.classList.add('active');
          var p = modal.querySelector('.rs-panel[data-panel="' + tab.getAttribute('data-tab') + '"]');
          if (p) p.classList.add('active');
          if (e && e.isTrusted) rsTrack('ring_sizer_tab', { sizer_tab: tab.getAttribute('data-tab') });
        });
      });

      if (cal) cal.addEventListener('input', update);
      if (size) size.addEventListener('input', update);

      var body = document.getElementById('rsChartBody');
      if (body) {
        RS_SIZES.forEach(function (s) {
          var tr = document.createElement('tr');
          tr.innerHTML = '<td>' + s.us + '</td><td>' + s.dia + ' mm</td><td>' + s.circ + ' mm</td><td>' + s.uk + '</td><td>' + s.eu + '</td>';
          body.appendChild(tr);
        });
      }
    }

    /* sticky add-to-cart — show once the main ATC has scrolled above the viewport.
       Uses a scroll listener (reliable everywhere) rather than IntersectionObserver. */
    var sticky = document.getElementById('cspSticky');
    var atc = document.querySelector('.csp-atc');
    if (sticky && atc) {
      var syncSticky = function () {
        sticky.classList.toggle('show', atc.getBoundingClientRect().bottom <= 0);
      };
      window.addEventListener('scroll', syncSticky, { passive: true });
      window.addEventListener('resize', syncSticky);
      syncSticky();
    }

    /* related products — fetch Shopify product recommendations and swap them in
       (replaces the fallback collection rendered on first paint) */
    var recBody = document.querySelector('.couples-related [data-csp-recommendations]');
    if (recBody) {
      fetch(recBody.getAttribute('data-csp-recommendations'), { priority: 'low' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('.cs-prow');
          if (fresh) { recBody.innerHTML = ''; recBody.appendChild(fresh); }
        })
        .catch(function () {});
    }
  });
})();